import React, { Component, Fragment } from 'react';
// import AnalyticsManager from '../../functions/analytics';
import RecurveBaseComponent from '../RecurveBaseComponent';
import RecurveUtility from '../../functions/utility';
import BootstrapModal from "../../themes/streamlined/Modal";

const WelcomeContext = React.createContext({categories:[], items:[], hasServerError: false, hasPopupError: false});

class Welcome extends Component {
    constructor(props) {
        super(props);
        this.state = {
            categories: [],
            items: [],
            hasServerError: false,
            hasPopupError: false,
            loading: true,
            display_status_msg: false,
            error_body_content: null,
            error_title: null
        };
        this.parseServerData = this.parseServerData.bind(this);
        this.utility = {...RecurveUtility};
        this.WelcomeContext = WelcomeContext;
    }

    componentDidMount() {
        if (session.store.site_enabled) {
            if(session.store.statusMessage && localStorage.getItem('status_msg_active') !== `0`) {
                this.setState({
                    body_content: session.store.statusMessage,
                    error_title: `Before you order!`,
                    display_status_msg: true
                }, () => {
                    localStorage.setItem('status_msg_active', '0');
                })
            }
        } else {
            this.setState({
                display_status_msg: true,
                error_title: `Welcome! We're glad you're back.`,
                body_content: `We have turned off our online ordering briefly, but hope to turn it back on soon.`
            }, () => {
                localStorage.setItem('status_msg_active', '0');
            })
        }
        this.utility.initiateGetRequest('homepage/api', this).then( (response) => {
            if(response.status > 300 && response.status < 400) document.location.reload() //Follow redirects
            if(response.ok) {
                response.json().then( (resJ) => {
                    this.parseServerData(resJ);
                });
            }else {
                if(response.status === 422) {
                    response.json().then( (resJ) => {
                        this.setState({error: resJ});
                    }, (jsonParseFailure) => {
                        console.log(jsonParseFailure);
                    });
                }else {
                    response.json().then( (resJ) => {
                        this.setState({error: resJ, hasServerError: true})
                    }, (jsonParseFailure) => {
                        console.log(jsonParseFailure);
                    });
                }
            }
        }, (rejection) => {
            console.log(rejection);
        });
    }

    parseServerData(result) {
        let categories = result.categories;
        //Create an array to hold all item navs in flat structure for analytics to consume
        let allItems = [];
        categories.forEach( (val, ind, arr)=> {
            //Get both items
            let leftItem = val.item_navigations[0];
            let rightItem = val.item_navigations[1];

            let item1 = {categoryID: val.id, ...leftItem};
            let item2 = {categoryID: val.id, ...rightItem};

            allItems.push(item1);
            allItems.push(item2);
        });
        //Before we set state, make sure to trigger analytics impressions for those items
        // AnalyticsManager.registerItemImpressions(allItems, 'Welcome', true);
        this.setState({categories: categories, items: allItems, loading: false});
    }

    render() {
        return (
        <WelcomeContext.Provider value={this.state}>
            <RecurveBaseComponent loading={this.state.loading} error={this.state.error} hasServerError={this.state.hasServerError} hasPopupError={this.state.hasPopupError} content={this.props.content} />
            {this.state.display_status_msg && <BootstrapModal title={this.state.error_title} bodyContent={this.state.body_content} />}
        </WelcomeContext.Provider>
        );
    }
}
export {Welcome, WelcomeContext};
